/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconVest: {
  name: 'vest';
  data: string;
} = {
  name: 'vest',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 612 612"><path d="M291.354 1320.523v-23.906c-4.781-4.781-9.563-9.563-9.563-14.344 0-9.563 4.781-23.906 19.125-28.688 0 0-4.781-4.781-9.563-4.781H277.01c0 9.563-9.563 14.344-14.344 14.344s-14.344-4.781-14.344-14.344h-14.344c-4.781 0-9.563 4.781-9.563 4.781 14.344 4.781 19.125 19.125 19.125 28.688 0 4.781-4.781 9.563-9.563 14.344v23.906c9.563 4.781 19.125 9.563 28.687 9.563 9.565-.001 19.128-4.782 28.69-9.563z" transform="matrix(7.5 0 0 7.05882 -1664 -8795.97)"/></svg>`,
};
